import "../../Components/Page/Page.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import ImageComp from "../../Components/ImageContainer/ImageComp";
import ManufacturePic from "../../Images/Investor/ManufacturePic.png"


const GoToMarket: React.FC = () => {
    return (
        <div className="sectionContainer">
            <SecHeader title="Go To Market" />
            <SubSection>
                <ImageComp imageSource={ManufacturePic} width={"Clamp(18rem, 25vw, 36rem)"} />
                <div className="description-container">
                    <b>1. With any one of our USPs we offer Value:​</b>
                    <p>
                        <ul>
                            <li>Greater fuel efficiency</li>
                            <li>Higher power to weight</li>
                            <li>Longer lasting and low maintenance</li>
                            <li>Easier to manufacture</li>
                            <li>Greener with better emissions</li>
                            <li>Flex-fuel capabilities</li>
                        </ul>
                    </p>{" "}
                    <b>2. 103 Manufacturers make up $2.1T of the $3T market, with median & average revenues of $4B​ and $21B.</b>
                    <p>
                        
                    </p>{" "}
                    <b>3. Our fees are well "within reach," ensuring costs are never barriers, and we know our target clients.​</b>
                    <p>
                        
                    </p>{" "}
                    <b>4. We already have 2 producer IP rights agreements.​</b>{" "}
                    
                </div>
            </SubSection>
        </div>
    );
};

export default GoToMarket;